import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC31BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import { ArchivoOpcionalComponent } from '../../ArchivosComponents/ArchivoOpcionalComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_31, actualizarFC_31Estatus, actualizarFC_31Solicitud,
    actualizarFileFC_31, agregarFileFC_31,
} from '../../../redux/DucksBeneficiario/FC_31Ducks';
import moment from 'moment'

const DocumentacionFC_31Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_31Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_31Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesDuckMuestreo = useSelector(store => store.FC_31Solicitud.filesMuestreo)
    const filesDuckIngreso = useSelector(store => store.FC_31Solicitud.filesIngreso)
    let filesMuestreoMap = useSelector(store => store.FC_31Solicitud.filesMuestreoMap)
    let filesIngresoMap = useSelector(store => store.FC_31Solicitud.filesIngresoMap)
    let filesMap = useSelector(store => store.FC_31Solicitud.filesProductosMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        let countArchivos = 0
        const totalFilesMuestreo = (filesMuestreo.filter(file => file.estatus === true)).length
        const totalFilesIngreso = (filesIngreso.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesMuestreo + totalFilesIngreso

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc31_solicitudseguimiento: data.idfc31_solicitudseguimiento }
            await dispatch(actualizarFC_31Solicitud({ solicitud: solicitud }))
            setFolio(data.folio)
            const idSolicitud = data.idfc31_solicitudseguimiento
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_31 = 6
            const tabla = tablaFC_31
            await dispatch(actualizarFC_31Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_31())
            setEnvioCorrecto(true)
        }
    }


    React.useEffect(() => {
        if (filesDuckMuestreo) {
            let newFiles = []
            for (const file in filesDuckMuestreo) {
                const { ...newFile } = filesDuckMuestreo?.[file]
                newFiles.push(newFile)
            }
            setFileMuestreo(newFiles)
        }
    }, [data])
    React.useEffect(() => {
        if (filesDuckIngreso) {
            let newFiles = []
            for (const file in filesDuckIngreso) {
                const { ...newFile } = filesDuckIngreso?.[file]
                newFiles.push(newFile)
            }
            setFileIngreso(newFiles)
        }
    }, [data])

    //FILES Muestreo
    const [filesMuestreo, setFileMuestreo] = React.useState([])
    const handdleFileMuestreo = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_31/agregarNuevoFC_31AnexosArchivosMuestreo'
        }
        const result = await dispatch(agregarFileFC_31(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_31archivomuestreo
            objectFile.estatus = true
            setFileMuestreo(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevMuestreo = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesMuestreo.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_31/actualizarFormatoFC31_AnexosArchivosMuestreo'
                }
                const result = await dispatch(actualizarFileFC_31(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_31/agregarNuevoFC_31AnexosArchivosMuestreo'
                    }
                    result = await dispatch(agregarFileFC_31(data))
                }
                if (result.payload.data?.data) {
                    setFileMuestreo(newFiles)
                    return true
                } else {
                    const newFiles = filesMuestreo.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileMuestreo(newFiles)
                    return false
                }
            }
        }
    }

    const FilesGeneralesMustreo = () => {
        return (
            <Collapsible trigger="Documentación de muestreo" className='mb-3'>
                {data?.fc_31_anexomuestreo?.map((anexo, index) => (
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <label className='text-center'>Producto:{Number(1) + Number(index)}</label>
                        <ArchivoOpcionalComponent api={{ handdleFile: handdleFileMuestreo, handdleRemovePrev: handdleRemovePrevMuestreo, files: filesMuestreo }}
                            id={`DMAL${index}`} tabla={"FC_31_anexos"}
                            filesMap={filesMuestreoMap} textLabel={`Análisis de laboratorio: `}
                            textoTooltip='En cumplimiento con el apartado 4.3 de la NOM-070-SCFI-2016.'
                            idAnexoFK={anexo?.idfc31_anexomuestreo} />
                    </div>
                ))}
            </Collapsible>
        )
    }

    //FILES Muestreo
    const [filesIngreso, setFileIngreso] = React.useState([])
    const handdleFileIngreso = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_31/agregarNuevoFC_31AnexosArchivosIngreso'
        }
        const result = await dispatch(agregarFileFC_31(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_31archivoingreso
            objectFile.estatus = true
            setFileIngreso(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevIngreso = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesIngreso.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_31/actualizarFormatoFC31_AnexosArchivosIngreso'
                }
                const result = await dispatch(actualizarFileFC_31(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_31/agregarNuevoFC_31AnexosArchivosIngreso'
                    }
                    result = await dispatch(agregarFileFC_31(data))
                }
                if (result.payload.data?.data) {
                    setFileIngreso(newFiles)
                    return true
                } else {
                    const newFiles = filesIngreso.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileIngreso(newFiles)
                    return false
                }
            }
        }
    }
    const FilesGeneralesIngreso = () => {
        return (
            <Collapsible trigger="Documentación de ingreso de maduracion" className='mb-3'>
                {data?.fc_31_anexoingresomaduracion?.map((anexo, index) => (
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <label className='text-center'>Producto:{Number(1) + Number(index)}</label>
                        <ArchivoOpcionalComponent api={{ handdleFile: handdleFileIngreso, handdleRemovePrev: handdleRemovePrevIngreso, files: filesIngreso }}
                            id={`DIAL${index}`} tabla={"FC_31_anexos"}
                            filesMap={filesIngresoMap} textLabel={`Análisis de laboratorio: `}
                            textoTooltip='En cumplimiento con el apartado 4.3 de la NOM-070-SCFI-2016.'
                            idAnexoFK={anexo?.idfc31_anexoingresomaduracion} />
                    </div>
                ))}
            </Collapsible>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {data.muestreo && FilesGeneralesMustreo()}
                    {data.ingresomaduracion && FilesGeneralesIngreso()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envio</button>
                    </div>
                }
            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_31Component)
